import {
  Paper,
  Grid,
  Button,
  Alert,
  Switch,
  ToggleButtonGroup,
  ToggleButton,
  Tabs,
  Tab,
  Box,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Stack,
  TextField,
} from "@mui/material";
import React, { useContext } from "react";

import constant from "../Costanti/Constant.js";
import "dayjs/locale/it";

import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import { loadStripe } from "@stripe/stripe-js";
import InfoUserSocieta from "../infoUserSocieta";
import { Context } from "../Context.js";
import { useNavigate, useLocation } from "react-router-dom";
import PersonIcon from "@mui/icons-material/Person";
import GroupsIcon from "@mui/icons-material/Groups";

import "./Abbonamento.css";

const Utenze = {
  ADMIN: 1,
  USER: 2,
  SOCIETA: 3,
};

const AbbonamentoSocietaGruppo = () => {
  const stripePromise = loadStripe(
    "pk_live_51LvMKTIUBaKEna1TVuf3hbmFwVkBBzOEfsm0M7Jp6vsm0i7UsuPG87XyGnD77ANmLPs38bhhKECYn43B0fF9geSL00efgDLihY"
  );

  const { token, idTipoUtente } = useContext(Context);

  const navigate = useNavigate();
  const location = useLocation();

  // Tabs in testa (gemelle con Corso)
  const TABS = [
    {
      value: "/abbonamentoSocietaGruppo",
      label: "Iscrizione società",
      icon: <PersonIcon />,
    },
    {
      value: "/abbonamentoSocietaCorso",
      label: "Acquisto abbonamento corsi",
      icon: <GroupsIcon />,
    },
  ];

  const currentTab =
    TABS.find((t) => location.pathname.startsWith(t.value))?.value ||
    "/abbonamentoSocietaGruppo";

  // Stato
  const [costoAbbonamento, setCostoAbbonamento] = React.useState("0");
  const [tipoAbbonamento, setTipoAbbonamento] = React.useState("");
  const [tipoGruppo, setTipoGruppo] = React.useState("");

  const [isRichiediFattura, setIsRichiediFattura] = React.useState(false);

  const [bookableField, setBookableField] = React.useState([]);
  const [selectedFields, setSelectedFields] = React.useState(new Set());
  const [num, setNum] = React.useState(0);

  const [alertError, setAlertError] = React.useState(false);
  const [alertOk, setAlertOk] = React.useState(false);
  const [msgAlert, setMsgAlert] = React.useState("");

  const [DatePickerAnno, setDatePickerAnno] = React.useState(false);
  const [DatePickerMese, setDatePickerMese] = React.useState(false);
  const [DatePickerGiorno, setDatePickerGiorno] = React.useState(false);

  const [valueData, setValueData] = React.useState(dayjs());

  const [visualizzaPagina, setVisualizzaPagina] = React.useState(false);
  const [isClickableButton, setIsClickableButton] = React.useState(true);

  // Effects
  React.useEffect(() => {
    if (idTipoUtente !== Utenze.SOCIETA) {
      navigate("/");
    } else {
      setVisualizzaPagina(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    richiestaCampi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    calcoloCostoAbbonamento();
  }, [tipoAbbonamento, tipoGruppo, num]); // include num!

  // API
  const richiestaCampi = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Access-Control-Allow-Origin", "*");
    myHeaders.append(
      "Access-Control-Allow-Headers",
      "Access-Control-Allow-Headers , X-Requested-With, Content-Type, Authorization"
    );
    myHeaders.append(
      "Access-Control-Allow-Methods",
      "PUT, GET, POST, DELETE, OPTIONS"
    );
    myHeaders.append("Cache-Control", "no-cache, no-store, must-revalidate");
    myHeaders.append("Pragma", "no-cache");
    myHeaders.append("Authorization", `Bearer ${token}`);

    fetch(constant.RICHIESTACAMPI, {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    })
      .then((response) => {
        if (!response.ok) {
          throw navigate("/");
        }
        return response.json();
      })
      .then((fieldList) =>
        setBookableField(fieldList.map((field) => field["NomeCampo"]))
      )
      .catch((error) => console.log("error", error));
  };

  // Logica business
  const calcoloCostoAbbonamento = () => {
    if (
      tipoGruppo !== "" &&
      tipoAbbonamento !== "" &&
      selectedFields.size !== 0
    ) {
      if (tipoGruppo === "20") {
        if (tipoAbbonamento === "Mensile") setCostoAbbonamento("100");
        else if (tipoAbbonamento === "Trimestrale") setCostoAbbonamento("250");
        else setCostoAbbonamento("1000");
      }

      if (tipoGruppo === "40") {
        if (tipoAbbonamento === "Mensile") setCostoAbbonamento("200");
        else if (tipoAbbonamento === "Trimestrale") setCostoAbbonamento("500");
        else setCostoAbbonamento("2000");
      }

      if (tipoGruppo === "41") {
        if (tipoAbbonamento === "Mensile") setCostoAbbonamento("400");
        else if (tipoAbbonamento === "Trimestrale") setCostoAbbonamento("1000");
        else setCostoAbbonamento("4000");
      }
    } else {
      setCostoAbbonamento("0");
    }
  };

  // Handlers
  const handleChangeRadioButtonGruppi = (event) => {
    setTipoGruppo(event.target.value);
  };

  const handleChange = (event) => {
    const v = event.target.value; // "Mensile" | "Trimestrale" | "Annuale"
    setTipoAbbonamento(v);

    if (v === "Annuale") {
      setDatePickerAnno(false);
      setDatePickerMese(false);
      setDatePickerGiorno(true);
    } else if (v === "Trimestrale") {
      setDatePickerAnno(false);
      setDatePickerMese(false);
      setDatePickerGiorno(true);
    } else if (v === "Mensile") {
      setDatePickerAnno(false);
      setDatePickerMese(false);
      setDatePickerGiorno(true);
    } else if (v === "Giornaliero") {
      setDatePickerAnno(false);
      setDatePickerMese(false);
      setDatePickerGiorno(true);
    }
  };

  const buttonCLickPagamento = () => {
    buttonCLick();
  };

  const buttonCLick = () => {
    setIsClickableButton(false);
    let _dataInizioAbbonamento = "";
    let _dataFineAbbonamento = "";

    if (num === 0) {
      setMsgAlert("Errore: selezionare un abbonamento");
      setAlertError(true);
      setAlertOk(false);
      setIsClickableButton(true);
    } else {
      setAlertError(false);
      if (tipoAbbonamento === "Giornaliero") {
        let annoInizio = valueData.year().toString();
        let meseInizio = valueData.month() + 1;
        let giornoInizio = valueData.date();

        if (meseInizio < 10) meseInizio = `0${meseInizio}`;
        if (giornoInizio < 10) giornoInizio = `0${giornoInizio}`;

        _dataInizioAbbonamento = `${annoInizio}${meseInizio}${giornoInizio}000001`;
        _dataFineAbbonamento = `${annoInizio}${meseInizio}${giornoInizio}235959`;
      }

      if (tipoAbbonamento === "Mensile") {
      let annoInizio = valueData.year().toString();
      let meseInizio = (valueData.month() + 1).toString();
      let meseFine = (valueData.month() + 2).toString();
      let giornoInizio = valueData.date().toString();

      if (meseInizio < 10) {
        meseInizio = `0${meseInizio}`;
      }

      if (meseFine < 10) {
        meseFine = `0${meseFine}`;
      }

      if (giornoInizio < 10) {
        giornoInizio = `0${giornoInizio}`;
      }

      _dataInizioAbbonamento = `${annoInizio}${meseInizio}${giornoInizio}000001`;
      if (meseInizio === "02") {
        _dataFineAbbonamento = `${annoInizio}${(parseInt(meseInizio) + 1).toString().padStart(2, "0")}${giornoInizio}235959`;
      } else if (
        meseInizio === "04" ||
        meseInizio === "06" ||
        meseInizio === "09" ||
        meseInizio === "11"
      ) {
        _dataFineAbbonamento = `${annoInizio}${(parseInt(meseInizio) + 1).toString().padStart(2, "0")}${giornoInizio}235959`;
      } else {
        if (meseFine === "02" && giornoInizio > 28) {
          console.log(giornoInizio);
          giornoInizio = "28";
        } else if (
          (meseFine === "04" ||
            meseFine === "06" ||
            meseFine === "09" ||
            meseFine === "11") &&
          giornoInizio > 30
        ) {
          giornoInizio = "30";
        }
        _dataFineAbbonamento = `${annoInizio}${(parseInt(meseInizio) + 1).toString().padStart(2, "0")}${giornoInizio}235959`;
      }
    }

    if (tipoAbbonamento === "Trimestrale") {
        // L'utente sceglie solo mese e anno -> imposto giorno 1
        const dataInizio = valueData.startOf("month");   // <-- primo giorno del mese scelto
      
        let annoInizio = dataInizio.year().toString();
        let meseInizio = (dataInizio.month() + 1).toString();
        let giornoInizio = valueData.date().toString();

        
      
        // Calcolo data di fine: 90 giorni dopo il primo giorno del mese
        const dataFine = dataInizio.add(3, "month");
      
        let annoFine = dataFine.year().toString();
        let meseFine = (dataFine.month() + 1).toString().padStart(2, "0");

        if (meseInizio < 10) {
          meseInizio = `0${meseInizio}`;
        }

        if (giornoInizio < 10) {
          giornoInizio = `0${giornoInizio}`;
        }

        // Data inizio (formato richiesto)
        _dataInizioAbbonamento = `${annoInizio}${meseInizio}${giornoInizio}000001`;

        // console.log("mese fine prima dei controlli: " + meseFine);
        // console.log("giorno fine prima dei controlli: " + giornoFine);
        switch (meseFine) {
          case "02":
            if (giornoInizio > 28) giornoInizio = "28";
            break;
          case "04":
          case "06":
          case "09":
          case "11":
            if (giornoInizio > 30) giornoInizio = "30";
            break;
          default:
            if (giornoInizio > 31) giornoInizio = "31";
        }
        // Data fine (formato richiesto)
        console.log(`Data fine calcolata: ${annoFine}-${meseFine}-${giornoInizio}`);
        _dataFineAbbonamento = `${annoFine}${meseFine}${giornoInizio}235959`;
        console.log(`Data inizio: ${_dataInizioAbbonamento}, Data fine: ${_dataFineAbbonamento}`);
    }

    /*if (tipoAbbonamento === "Trimestrale") {
      let annoInizio = valueData.year().toString();
      let meseInizio = (valueData.month() + 1).toString();
      let meseFine = (valueData.month() + 3).toString();
      if (valueData.month() > 9) {
        meseFine = (12).toString();
        console.log(meseFine);
      }

      if (meseInizio < 10) {
        meseInizio = `0${meseInizio}`;
      }

      if (meseFine < 10) {
        meseFine = `0${meseFine}`;
      }

      _dataInizioAbbonamento = `${annoInizio}${meseInizio}01000001`;
      if (meseFine === "02") {
        _dataFineAbbonamento = `${annoInizio}${meseFine}28235959`;
      } else if (
        meseFine === "04" ||
        meseFine === "06" ||
        meseFine === "09" ||
        meseFine === "11"
      ) {
        _dataFineAbbonamento = `${annoInizio}${meseFine}30235959`;
      } else {
        _dataFineAbbonamento = `${annoInizio}${meseFine}31235959`;
      }
    }*/

    if (tipoAbbonamento === "Annuale") {
      let annoInizio = valueData.year().toString();
      let meseInizio = (valueData.month() + 1).toString();
      let giornoInizio = valueData.date().toString();

      let annoFine = (valueData.year() + 1).toString();

      if (meseInizio < 10) {
        meseInizio = `0${meseInizio}`;
      }

      if (giornoInizio < 10) {
        giornoInizio = `0${giornoInizio}`;
      }


      _dataInizioAbbonamento = `${annoInizio}${meseInizio}${giornoInizio}000001`;
      console.log(`Data inizio: ${_dataInizioAbbonamento}`);
      _dataFineAbbonamento = `${annoFine}${meseInizio}${giornoInizio}235959`;
      console.log(`Data fine prima dei controlli: ${_dataFineAbbonamento}`);
    }

      sendApiData(_dataInizioAbbonamento, _dataFineAbbonamento);
    }
  };

  const sendApiData = (dataInizioAbbonamento, dataFineAbbonamento) => {
    const arrCampi = [...selectedFields];

    const now = new Date();
    const yyyy = now.getFullYear();
    const mm = String(now.getMonth() + 1).padStart(2, "0");
    const dd = String(now.getDate()).padStart(2, "0");
    const hh = String(now.getHours()).padStart(2, "0");
    const min = String(now.getMinutes()).padStart(2, "0");
    const sec = String(now.getSeconds()).padStart(2, "0");
    const today = `${yyyy}${mm}${dd}${hh}${min}${sec}`;

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Access-Control-Allow-Origin", "*");
    myHeaders.append(
      "Access-Control-Allow-Headers",
      "Access-Control-Allow-Headers , X-Requested-With, Content-Type, Authorization"
    );
    myHeaders.append(
      "Access-Control-Allow-Methods",
      "PUT, GET, POST, DELETE, OPTIONS"
    );
    myHeaders.append("Cache-Control", "no-cache, no-store, must-revalidate");
    myHeaders.append("Pragma", "no-cache");
    myHeaders.append("Authorization", `Bearer ${token}`);


    
    console.log("data inizio "+dataInizioAbbonamento);
    console.log("data fine "+dataFineAbbonamento);

    const body = JSON.stringify({
      createCheckoutSession: 1,
      tipoGruppo: tipoGruppo,
      idCampo: arrCampi,
      dataInizio: dataInizioAbbonamento,
      dataFine: dataFineAbbonamento,
      tipoAbbonamento: tipoAbbonamento,
      isFattura: isRichiediFattura,
      insDate: today,
      updDate: today,
    });

    fetch(constant.BASE_URL + "payment_init_gruppi.php", {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
      body,
    })
      .then((response) => {
        if (!response.ok) {
          throw navigate("/");
        }
        return response.json();
      })
      .then((data) => {
        stripePromise.then((stripe) => {
          stripe.redirectToCheckout({ sessionId: data.sessionId });
        });
      })
      .then(handleResult);
  };

  const handleResult = (result) => {
    if (result?.error) {
      console.log(result.error.message);
    }
  };

  function calcolaCosto(n, unit) {
    const prezzo = Number(unit || 0);
    return isRichiediFattura ? n * prezzo * 1.22 : n * prezzo;
  }

  return (
    <div
      style={{
        backgroundColor: "#E5E5E5",
        height: "100vh",
      }}
    >
      {visualizzaPagina ? (
        <Grid>
          <InfoUserSocieta />
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Paper elevation={10} className="paperStyle">
              <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 1 }}>
                <Tabs
                  value={currentTab}
                  onChange={(_, newValue) => navigate(newValue)}
                >
                  {TABS.map((t) => (
                    <Tab
                      key={t.value}
                      value={t.value}
                      iconPosition="start"
                      label={t.label}
                      sx={{
                        fontSize: { xs: 12, sm: 14, md: 16 },
                        "&.Mui-selected": {
                          color: "primary.main",
                          fontWeight: 700,
                        },
                      }}
                    />
                  ))}
                </Tabs>
              </Box>

              <div style={{ padding: 20, minHeight: "75vh" }}>
                {/* Numero atleti */}
                <Grid align="center">
                  <FormControl fullWidth>
                    <h2 style={{ padding: "16px 0" }}>
                      Scegli il numero Atleti
                    </h2>
                    <RadioGroup
                      aria-labelledby="gruppo"
                      name="gruppo-radio-group"
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                        justifyContent: "space-around",
                      }}
                    >
                      {[
                        { label: "Da 11 a 20", value: 20 },
                        { label: "Da 21 a 40", value: 40 },
                        { label: "Maggiore di 40", value: 41 },
                      ].map(({ label, value }) => (
                        <FormControlLabel
                          key={value}
                          value={value}
                          name={label}
                          control={
                            <Radio onChange={handleChangeRadioButtonGruppi} />
                          }
                          label={label}
                          sx={{
                            m: 1,
                            width: { xs: "100%", sm: "30%", md: "30%" },
                            height: "56px",
                            border: "1px solid #5E2367",
                            borderRadius: 2,
                            bgcolor:
                              tipoGruppo === String(value)
                                ? "#5E236730"
                                : "transparent",
                          }}
                        />
                      ))}
                    </RadioGroup>
                  </FormControl>
                </Grid>

                {/* Campo multiplo */}
                <Grid align="center">
                  <h2 style={{ padding: "16px 0" }}>Scegli il tuo Campo</h2>
                  <ToggleButtonGroup
                    value={[...selectedFields]}
                    onChange={(_, newSelection) => {
                      const next = new Set(newSelection);
                      setSelectedFields(next);
                      setNum(next.size);
                    }}
                    aria-label="selezione campo"
                  >
                    {bookableField.map((item, index) => (
                      <ToggleButton
                        key={index}
                        value={index + 1}
                        selected={selectedFields.has(index + 1)}
                        aria-label={item}
                        sx={{
                          "&.Mui-selected": {
                            bgcolor: "primary.main",
                            color: "white",
                            "&:hover": { bgcolor: "primary.dark" },
                          },
                        }}
                      >
                        {item}
                      </ToggleButton>
                    ))}
                  </ToggleButtonGroup>

                  {/* Durata */}
                  <h2 style={{ padding: "16px 0" }}>Scegli la Durata</h2>
                  <div
                    style={{ display: "flex", flexDirection: "row", gap: 20 }}
                  >
                    <div style={{ width: "50%", display: "flex" }}>
                      <FormControl style={{ width: "100%" }}>
                        <RadioGroup
                          aria-labelledby="periodo"
                          name="radio-buttons-group"
                        >
                          {["Mensile", "Trimestrale", "Annuale"].map(
                            (label) => (
                              <FormControlLabel
                                key={label}
                                value={label}
                                control={<Radio onChange={handleChange} />}
                                label={label}
                                sx={{
                                  m: 1,
                                  width: "100%",
                                  height: "56px",
                                  border: "1px solid #5E2367",
                                  borderRadius: 2,
                                  backgroundColor:
                                    tipoAbbonamento === label
                                      ? "#5E236730"
                                      : "transparent",
                                }}
                              />
                            )
                          )}
                        </RadioGroup>
                      </FormControl>
                    </div>

                    {/* Calendario */}
                    <div
                      style={{
                        width: "50%",
                        display: "flex",
                        alignItems: "start",
                        marginTop: 8,
                      }}
                    >
                      <LocalizationProvider
                        dateAdapter={AdapterDayjs}
                        adapterLocale="it"
                      >
                        <Stack spacing={3} sx={{ width: "100%" }}>
                          {DatePickerAnno && (
                            <DatePicker
                              views={["year"]}
                              label="Anno"
                              minDate={dayjs()}
                              value={valueData}
                              onChange={setValueData}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  helperText={null}
                                  fullWidth
                                />
                              )}
                            />
                          )}
                          {DatePickerMese && (
                            <DatePicker
                              views={["year", "month"]}
                              label="Anno e mese"
                              minDate={dayjs()}
                              value={valueData}
                              onChange={setValueData}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  helperText={null}
                                  fullWidth
                                />
                              )}
                            />
                          )}
                          {DatePickerGiorno && (
                            <DatePicker
                              views={["day"]}
                              label="Data"
                              minDate={dayjs()}
                              value={valueData}
                              onChange={setValueData}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  helperText={null}
                                  fullWidth
                                />
                              )}
                            />
                          )}
                        </Stack>
                      </LocalizationProvider>
                    </div>
                  </div>

                  {/* Fattura */}
                  <Grid align="center" style={{ marginTop: 16 }}>
                    <FormControl>
                      <FormControlLabel
                        control={<Switch align="center" color="primary" />}
                        label="RICHIEDI FATTURA"
                        align="center"
                        onChange={() => setIsRichiediFattura((prev) => !prev)}
                        value={isRichiediFattura}
                        checked={!!isRichiediFattura}
                      />
                    </FormControl>
                  </Grid>

                  {/* Totale + CTA */}
                  <h2 style={{ padding: "16px 0" }}>
                    Totale: {calcolaCosto(num, costoAbbonamento)} €
                  </h2>

                  <Button
                    style={{
                      width: "auto",
                      marginTop: "20px",
                      marginBottom: "20px",
                    }}
                    disabled={!isClickableButton}
                    variant="contained"
                    size="medium"
                    fullWidth
                    onClick={buttonCLickPagamento}
                  >
                    Scegli piano
                  </Button>
                </Grid>
              </div>

              {alertError ? (
                <Alert padding="20" severity="error">
                  {msgAlert}
                </Alert>
              ) : null}
              {alertOk ? <Alert severity="success">{msgAlert}</Alert> : null}
            </Paper>
          </div>
        </Grid>
      ) : null}
    </div>
  );
};

export default AbbonamentoSocietaGruppo;
